import React from 'react';

export function useFunctionRef(defaultValue) {
    const ref = React.useRef();
    const [loading, setLoading] = React.useState(false);
    const setRef = React.useCallback(func => {
        if (func) {
            ref.current = func;
        }
        return loading;
    }, [loading]);
    const callRef = React.useCallback(async (...args) => {
        let result;
        setLoading(true);
        try {
            if (ref.current) {
                result = await ref.current(...args);
            } else if (defaultValue !== undefined) {
                result = defaultValue;
            }
            setLoading(false);
            return result;
        } catch (err) {
            setLoading(false);
            throw err;
        }
    }, [defaultValue]);
    return [setRef, callRef, ref];
}